import { render, staticRenderFns } from "./PreferenceSetting.vue?vue&type=template&id=2ba243b7&scoped=true"
import script from "./PreferenceSetting.vue?vue&type=script&lang=js"
export * from "./PreferenceSetting.vue?vue&type=script&lang=js"
import style1 from "./PreferenceSetting.vue?vue&type=style&index=1&id=2ba243b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba243b7",
  null
  
)

export default component.exports